import "./App.css";
import sbadmin2 from "../src/css/sb-admin-2.css";
import sbadmin21 from "../src/css/sb-admin-2.min.css";
import login from "../src/css/login.css";

import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Sidebar from "./components/Sidebar";
import InfoUsuarios from "./components/GestionUsuarios/InfoUsuarios";
import InfoReportes from "./components/GestionReportes/InfoReportes";
import InfoPermisos from "./components/GestionPermisos/InfoPermisos";
import Login from "./components/Login";
import Footer from "./components/Footer";
import ConsultarReporte from "./components/GestionReportes/ConsultarReporte";
import ErrorLogin from "./components/error";

import Cookies from "universal-cookie";
import { useEffect, useState } from "react";

const cookies = new Cookies();

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

function App() {
  const location = useLocation();

  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    const id = cookies.get("ID");
    const correo = cookies.get("correo");

    if (id && correo) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  }, [location.pathname]);

  if (isAuth === null) {
    return <div style={{ marginTop: 100 }}>Inicializando...</div>;
  }

  return (
    <div className="App">
      {isAuth && <Sidebar isAuth={isAuth} />}
      <br></br>
      <br></br>
      <Routes>
        <Route
          path="/"
          element={!isAuth ? <Login /> : <Navigate to="/InfoUsuarios" />}
        />

        {/* 🔥 LIBRE (CLAVE) */}
        <Route
          path="/InfoReportes/:correo"
          element={<InfoReportes setIsAuth={setIsAuth} />}
        />

        <Route
          path="/InfoUsuarios"
          element={isAuth ? <InfoUsuarios /> : <Navigate to="/" />}
        />

        <Route
          path="/InfoPermisos"
          element={isAuth ? <InfoPermisos /> : <Navigate to="/" />}
        />

        <Route
          path="/ConsultaReporte/:id"
          element={isAuth ? <ConsultarReporte /> : <Navigate to="/" />}
        />

        <Route path="/error" element={<ErrorLogin />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default AppWrapper;
